import { useEffect } from 'react';
import {
  Box,
  Container,
  Paper,
  Stack,
} from '@mui/material';
import { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import { fetchAPI } from '../../../api/request';
import Alert from '../../../components/common/Alert.component';
import Back from '../../../components/common/Back.component';
import Loading from '../../../components/common/Loading.component';
import AddView from '../../../views/Add.view';
import { getViewConfiguration } from '../../../module/contacts/conf/Data.conf';
import users_nautica from '../../../module/users_nautica';
import users_crew from '../../../module/users_crew';
import _ from 'lodash';
import { useLocation } from 'react-router-dom';
import UserTypeAndCrewResponsabilitySelector from '../../../components/userTypeAndCrewResponsability/UserTypeAndCrewResponsabilitySelector.component';
import YachtForm from '../../../components/yacht/YachtForm.component';
import { API as yachts } from '../../../module/yachts/api';

const ContactsAddPage = ({ module: { tag, create } }) => {
  const { jwt } = useSelector((state) => state.login);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);
  const [userTypeSelect, setUserTypeSelect] = useState(null);
  const [crewResponsability, setcrewResponsability] = useState(null);
  const location = useLocation();

  useEffect(() => {
    if (location.pathname.includes('/na/')) {
      setUserTypeSelect({
        label: 'Nautica',
        id: 'Nautica',
      });
    } else if (location.pathname.includes('/customers/')) {
      setUserTypeSelect({
        label: 'Crew',
        id: 'Crew',
      });
    }
  }, [location.pathname]);

  const handleChangeCrewResponsability = useCallback((newValue) => {
    setcrewResponsability(newValue);
  }, []);

  const onError = useCallback((error) => {
    setSuccess(false);
    setLoading(false);
    setError(error);
    // eslint-disable-next-line
  }, []);

  const onSuccess = useCallback(() => {
    setSuccess(true);
    setError(false);
    setLoading(false);
  }, [setSuccess, setError, setLoading]);

  const handleCreateUserNa = useCallback(
    (values) => {
      const data = {
        ...values,
        id_department: values?.id_department,
        subrole: values?.subrole,
      };
      fetchAPI(
        { path: '/users-nautica-departments', method: 'POST' },
        {},
        '',
        { data: { ...data } },

        jwt
      )
        .then(() => {
          onSuccess();
        })
        .catch(onError);
    },
    [jwt, onError, onSuccess]
  );
  const onSubmit = useCallback(
    (values) => {
      setSuccess(false);
      setError(false);
      setLoading(true);
      switch (_.toLower(userTypeSelect?.id)) {
        case 'nautica':
          fetchAPI(
            users_nautica.query.create.settings,
            {},
            '',
            { ...values },
            jwt
          )
            .then((resp) => {
              handleCreateUserNa({
                id_users_nautica: resp.data.id,
                ...values,
              });
            })
            .catch(onError);
          break;
        case 'crew':
          fetchAPI(users_crew.query.create.settings, {}, '', { ...values, crew_responsability: crewResponsability }, jwt)
            .then(() => {
              onSuccess();
            })
            .catch(onError);
          break;
        default:
          break;
      }
    },
    [userTypeSelect?.id, jwt, onError, crewResponsability, handleCreateUserNa, onSuccess]
  );

  const addViewConf = getViewConfiguration(userTypeSelect, crewResponsability, create.conf);

  return (
    <Container disableGutters={true} maxWidth={false} sx={{ height: '100%' }}>
      <Stack spacing={2} justifyContent='center' alignItems='center' width={1}>
        <Back title={tag} label={create?.back?.label} />
        {loading && <Loading />}
        {success && <Alert severity='success'>{'Contact created successfully'}</Alert>}
        {error && (
          <Alert severity="error">
            {error?.response?.data?.error?.message || 'An error has occurred'}
          </Alert>
        )}
        <Paper variant='outlined' sx={{ padding: 2, width: '100%' }}>
          <Box sx={{ padding: 2 }}>
            <UserTypeAndCrewResponsabilitySelector
              userTypeSelect={userTypeSelect}
              crewResponsability={crewResponsability}
              onChangeCrewResponsability={handleChangeCrewResponsability}
            />
            {addViewConf && (
              <AddView
                conf={addViewConf}
                disabled={loading || success}
                onAddSubmit={onSubmit}
                onAddError={onError}
                onAddSuccess={onSuccess}
                actions={userTypeSelect?.id === 'Crew' && <YachtForm api={yachts.selectWithStatus} />}
              />
            )}
          </Box>
        </Paper>
      </Stack>
    </Container>
  );
};

export default ContactsAddPage;